import React, {useEffect, useState} from "react";
import {
    convertUniversalDateTimeToPersianDateTime,
    RaikoBaseCardContainer, RaikoCreatorInfo,
    RaikoGridOneColumn, RaikoGridTwoColumn, RaikoHtmlTextEditor, RaikoLabel,
    RaikoSectionContainer,
    RaikoSimpleInputOutlined, showServerErrorMessage, showSuccessMessage,
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import {ProductService} from "../../../serverService/productService/ProductService";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";

export default function ProductBasicInfo({productId}) {


    const service = new ProductService()
    const loading = new LoadingHelper(useLoadingDispatcher())

    const [productTitle, setProductTitle] = useState("");
    const [productSlug, setProductSlug] = useState("");
    const [productDescription, setProductDescription] = useState("");
    const [createdAt, setCreatedAt] = useState("");
    const [createdBy, setCreatedBy] = useState("");
    const [updatedAt, setUpdatedAt] = useState("");
    const [updatedBy, setUpdatedBy] = useState("");


    const [buttonLoading, setButtonLoading] = useState(false)
    useEffect(() => {
        if (typeof service !== 'undefined') {
            getProductBasicInfoFromServer()
        }
    }, [productId]);

    function getProductBasicInfoFromServer() {
        loading.show()
        service.getProductDetails(productId)
            .then(response => {
                setProductTitle(response.title ? response.title : "");
                setProductSlug(response.slug ? response.slug : "");
                setProductDescription(response.description ? response.description : "")
                setCreatedAt(response.createdAt ? convertUniversalDateTimeToPersianDateTime(response.createdAt) : "")
                setCreatedBy(response.createdBy ? response.createdBy : "")
                setUpdatedAt(response.updatedAt ? convertUniversalDateTimeToPersianDateTime(response.updatedAt) : "")
                setUpdatedBy(response.updatedBy ? response.updatedBy : "")
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }

    function handleUpdateProductBasicInfo() {
        setButtonLoading(true)
        service.updateProductDetails(
            productId,
            productTitle,
            productSlug,
            productDescription,
        ).then(response => {
            showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
        }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setButtonLoading(false)
        })

    }


    return (
        <>
            <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                <RaikoBaseCardContainer>
                    <RaikoSectionContainer
                        title={"اطلاعات پایه"}
                        hasActionButton
                        actionButtonTitle={"بروزرسانی"}
                        actionButtonLoadingState={buttonLoading}
                        actionButtonOnclickWithValidation={handleUpdateProductBasicInfo}
                    >
                        <RaikoGridTwoColumn>
                            <RaikoSimpleInputOutlined
                                labelText={"عنوان"}
                                value={productTitle}
                                setValue={setProductTitle}
                                required
                            />
                            <RaikoSimpleInputOutlined
                                labelText={"slug"}
                                value={productSlug}
                                setValue={setProductSlug}
                                required
                            />
                        </RaikoGridTwoColumn>
                        <RaikoLabel text={"توضیحات"}/>
                        <RaikoHtmlTextEditor
                            text={productDescription}
                            setText={setProductDescription}
                        />
                    </RaikoSectionContainer>
                </RaikoBaseCardContainer>

                <RaikoCreatorInfo
                    createdBy={createdBy}
                    createdAt={createdAt}
                />
                <RaikoCreatorInfo
                    title={"آخرین بروزرسانی"}
                    createdBy={updatedBy}
                    createdByTitle={"ادمین"}
                    createdAt={updatedAt}
                    createdAtTitle={"تاریخ بروزرسانی"}
                />
            </RaikoGridOneColumn>

        </>
    )
}